module.exports = __webpack_public_path__ + "static/media/foto1.65285963.jpg";